import { Component, OnInit } from "@angular/core";

import { NbDialogService, NbToastrService } from "@nebular/theme";
import {
    NgxGalleryOptions,
    NgxGalleryImage,
    NgxGalleryAnimation,
} from "@kolkov/ngx-gallery";
import { ApiService } from "../services/api.service";

@Component({
    selector: "ngx-demo-apply",
    templateUrl: "./demo-apply.component.html",
    styleUrls: ["./demo-apply.component.scss"],
})
export class DemoApplyComponent implements OnInit {
    galleryOptions: NgxGalleryOptions[];
    screenshots: NgxGalleryImage[];

    public firstName: string;
    public lastName: string;
    public email: string;
    public companyName: string;
    public companyRole: string;
    public companyWebsite: string;
    public reference: string;
    public desiredDate: number;
    public demoPurpose: string;

    constructor(private _aS: ApiService, private _toastr: NbToastrService) {}

    ngOnInit(): void {
        this.screenshots = [
            {
                small: "../../assets/images/mtos-screenshot.png",
                medium: "../../assets/images/mtos-screenshot.png",
                big: "../../assets/images/mtos-screenshot.png",
            },
            {
                small: "../../assets/images/mtos-screenshot.png",
                medium: "../../assets/images/mtos-screenshot.png",
                big: "../../assets/images/mtos-screenshot.png",
            },
            {
                small: "../../assets/images/mtos-screenshot.png",
                medium: "../../assets/images/mtos-screenshot.png",
                big: "../../assets/images/mtos-screenshot.png",
            },
            {
                small: "../../assets/images/mtos-screenshot.png",
                medium: "../../assets/images/mtos-screenshot.png",
                big: "../../assets/images/mtos-screenshot.png",
            },
            {
                small: "../../assets/images/mtos-screenshot.png",
                medium: "../../assets/images/mtos-screenshot.png",
                big: "../../assets/images/mtos-screenshot.png",
            },
            {
                small: "../../assets/images/mtos-screenshot.png",
                medium: "../../assets/images/mtos-screenshot.png",
                big: "../../assets/images/mtos-screenshot.png",
            },
        ];

        this.galleryOptions = [
            {
                width: "600px",
                height: "400px",
                thumbnailsColumns: 4,
                imageAnimation: NgxGalleryAnimation.Slide,
                imageAutoPlay: true,
                imageAutoPlayInterval: 5000,
                imageAutoPlayPauseOnHover: true,
                imageInfinityMove: true,
            },
            // max-width 800
            {
                breakpoint: 800,
                width: "100%",
                height: "600px",
                imagePercent: 80,
                thumbnailsPercent: 20,
                thumbnailsMargin: 20,
                thumbnailMargin: 20,
            },
            // max-width 400
            {
                breakpoint: 400,
                preview: false,
            },
        ];
    }

    onApplyForDemo() {
        this._aS
            .applyForDemo(
                this.firstName,
                this.lastName,
                this.email,
                this.companyName,
                this.companyRole,
                this.reference,
                this.demoPurpose,
                new Date(this.desiredDate).getTime(),
                this.companyWebsite
            )
            .subscribe(() => {
                this._toastr.success(
                    "You have successfully applied for a demo, you will be notified with more information via the e-mail provided.",
                    "Application successfull!",
                    { duration: 10000 }
                );
                this.firstName = null;
                this.lastName = null;
                this.email = null;
                this.companyName = null;
                this.companyRole = null;
                this.reference = null;
                this.demoPurpose = null;
                this.desiredDate = null;
                this.companyWebsite = null;
            });
    }
}
